import { useDispatch } from 'react-redux';
import {
  ModalBody,
  ModalContent,
  Modal as ModalFlora,
  ModalFooter,
  ModalHeader,
} from '@grupoboticario/flora-react';

import { checkout } from 'core';
import { useSelector } from 'core/use-cases/utilities';
import { ResponsiveFloraTypography } from 'ui/components';
import { useRedirectToHome } from 'ui/hooks/useRedirectToHome';
import type { ModalPaymentMethodProps } from 'ui/components';

import { contentOptions } from './content-options';
import { useCheckout } from '../hooks';
import { ModalCloseButton } from 'ui/components/primitives/ModalCloseButton/ModalCloseButton';
import { theme } from 'ui/theme';
import { ModalStyles } from './Modal.styles';
import { MODAL_CONST } from 'ui/components/compounds/Modal/Modal.enums';

export const Modal = ({ isOpen, onClose, contentType }: ModalPaymentMethodProps) => {
  const dispatch = useDispatch();

  const { handleSetStep, isCreditCard } = useCheckout();
  const { redirectToHome } = useRedirectToHome();
  const { selectedPromotions } = useSelector(({ checkout }) => checkout);
  const { step: currentStep } = checkout.hooks.useCheckout();

  const handlerRedirectToHome = () => {
    redirectToHome();

    dispatch({ type: 'toggleNotification' });
  };

  const isPageReviewAndIsPaymentMethodCreditCard = currentStep === 'summary' && isCreditCard;
  const hasGiftSelectedAndCreditCard =
    selectedPromotions?.length > 0 && isPageReviewAndIsPaymentMethodCreditCard;

  const content =
    contentType === 'default'
      ? contentOptions['default']
      : hasGiftSelectedAndCreditCard
      ? contentOptions['giftAndCreditCard']
      : contentOptions['gift'];

  const eventPrimaryAction =
    contentType === 'redirectToCart'
      ? handlerRedirectToHome
      : contentType === 'redirectToHome'
      ? handlerRedirectToHome
      : handleSetStep;

  return (
    <ModalFlora open={isOpen}>
      <ModalContent data-testid={MODAL_CONST.TEST_ID}>
        <ModalCloseButton onClose={onClose} />
        <ModalHeader css={{ paddingBottom: 0 }}>
          <ResponsiveFloraTypography fontSize="subtitle">{content.title}</ResponsiveFloraTypography>
        </ModalHeader>
        <ModalBody
          css={{ paddingTop: `${theme.space['4']}`, paddingBottom: `${theme.space['4']}` }}
        >
          <ResponsiveFloraTypography fontSize="bodySmallStandard">
            {content.subtitle}
          </ResponsiveFloraTypography>
        </ModalBody>
        <ModalFooter>
          <ModalStyles.ButtonBack
            data-button-back-modal="true"
            hierarchy="secondary"
            onClick={onClose}
          >
            {currentStep === 'summary' ? content.secondaryLabel : 'Voltar para pagamento'}
          </ModalStyles.ButtonBack>
          <ModalStyles.ButtonNext data-button-next-modal="true" onClick={eventPrimaryAction}>
            {content.primaryLabel}
          </ModalStyles.ButtonNext>
        </ModalFooter>
      </ModalContent>
    </ModalFlora>
  );
};

export default Modal;
